<template>
  <el-form ref="form"
           :model="formData"
           label-width="200px">
    <div class="padding-20"
         style="color: #409eff;">一. 时间集 / 单个日期 <i style="color: #000;font-size: 13px;">默认值通过 searchDateProp参数控制 详见Avue 常用 option 参数说明</i></div>
    <br />
    <el-row>
      <!-- 单个时间 -->
      <el-col :span="10">
        <el-form-item label="单个日期:">
          <div class="block">
            <el-date-picker v-model="formData.searchDateToday"
                            style="width:100%"
                            type="date"
                            placeholder="请选择">
            </el-date-picker>
          </div>
        </el-form-item>
      </el-col>
      <!-- == end == -->

      <!-- 时间集-->
      <el-col :span="10">
        <el-form-item label="时间集:">
          <div class="block">
            <el-date-picker v-model="formData.searchDate"
                            style="width:100%"
                            type="datetimerange"
                            range-separator="-"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
            </el-date-picker>
          </div>
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-collapse v-model="activeNames.activeNames1">
          <el-collapse-item title="@code"
                            name="1">
            <prism-editor class="my-editor height-300"
                          v-model="DateCode1"
                          :highlight="highlighter"
                          readonly
                          line-numbers> </prism-editor>
          </el-collapse-item>
        </el-collapse>
      </el-col>
      <!-- == end == -->
    </el-row>

    <div class="padding-20"
         style="color: #409eff;">二. 时间集默认值<i style="color: #000;font-size: 13px;"> </i></div>
    <br />
    <el-row>
      <!-- 默认日期-->
      <el-col :span="10">
        <el-form-item label="时间集(默认一天):">
          <div class="block">
            <el-date-picker v-model="formData.searchDateDay"
                            style="width:100%"
                            type="datetimerange"
                            range-separator="-"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
            </el-date-picker>
          </div>
        </el-form-item>
      </el-col>
      <el-col :span="10">
        <el-form-item label="时间集(默认一个月):">
          <div class="block">
            <el-date-picker v-model="formData.searchDateMonth"
                            style="width:100%"
                            type="datetimerange"
                            range-separator="-"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
            </el-date-picker>
          </div>
        </el-form-item>
      </el-col>
      <br>
      <el-col :span="24">
        <el-collapse v-model="activeNames.activeNames2">
          <el-collapse-item title="@code"
                            name="1">
            <prism-editor class="my-editor height-300"
                          v-model="DateCode2"
                          :highlight="highlighter"
                          readonly
                          line-numbers> </prism-editor>
          </el-collapse-item>
        </el-collapse>
      </el-col>
    </el-row>
    <div class="padding-20"
         style="color: #409eff;">三. 时间组类型</div>
    <br />
    <el-row>
      <!-- == 时间组默认值 == -->
      <el-col :span="10"
              class="gather">
        <el-form-item label="时间组默认值(开始):">
          <div class="block">
            <el-date-picker v-model="formData.searchDateStart2"
                            style="width:100%"
                            type="datetime"
                            placeholder="请选择">
            </el-date-picker>
          </div>
        </el-form-item>
      </el-col>
      <el-col :span="10"
              class="gather">
        <el-form-item label="时间组默认值(结束):">
          <div class="block">
            <el-date-picker v-model="formData.searchDateEnd2"
                            style="width:100%"
                            type="datetime"
                            placeholder="请选择">
            </el-date-picker>
          </div>
        </el-form-item>
      </el-col>
      <!-- == 时间组默认值end == -->

      <!-- ==时间组== -->
      <el-col :span="10"
              class="know-form">
        <el-form-item label="时间组(开始):">
          <div class="block">
            <el-date-picker v-model="formData.searchDateStart"
                            style="width:100%"
                            type="datetime"
                            placeholder="请选择">
            </el-date-picker>
          </div>
        </el-form-item>
      </el-col>

      <el-col :span="10"
              class="know-form">
        <el-form-item label="时间组(结束):">
          <div class="block">
            <el-date-picker v-model="formData.searchDateEnd"
                            style="width:100%"
                            type="datetime"
                            placeholder="请选择">
            </el-date-picker>
          </div>
        </el-form-item>
      </el-col>
      <!-- ==时间组end == -->

      <el-col :span="24">
        <el-collapse v-model="activeNames.DateCode3">
          <el-collapse-item title="@code"
                            name="1">
            <prism-editor class="my-editor height-300"
                          v-model="DateCode3"
                          :highlight="highlighter"
                          readonly
                          line-numbers> </prism-editor>
          </el-collapse-item>
        </el-collapse>
      </el-col>
    </el-row>

    <div class="padding-20"
         style="color: #409eff;">四. 日期组默认30天 <i style="color: #000;font-size: 13px;"></i></div>
    <br />
    <el-row>
      <el-col :span="10"
              class="gather">
        <el-form-item label="日期组默认30天(开始):">
          <div class="block">
            <el-date-picker v-model="formData.thirtyDaysStart"
                            style="width:100%"
                            type="date"
                            placeholder="请选择">
            </el-date-picker>
          </div>
        </el-form-item>
      </el-col>
      <el-col :span="10"
              class="gather">
        <el-form-item label="日期组默认30天(结束):">

          <el-date-picker v-model="formData.thirtyDaysEnd"
                          style="width:100%"
                          type="date"
                          placeholder="请选择">
          </el-date-picker>

        </el-form-item>
      </el-col>
      <br>
      <el-col :span="24">
        <el-collapse v-model="activeNames.DateCode4">
          <el-collapse-item title="@code"
                            name="1">
            <prism-editor class="my-editor height-300"
                          v-model="DateCode4"
                          :highlight="highlighter"
                          readonly
                          line-numbers> </prism-editor>
          </el-collapse-item>
        </el-collapse>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import { getAllWeekBeforeNowFn } from "@/util/date";
import { Desc, DescMethod } from '../util/demodesc';  //日志及描述说明文件
DescMethod.initialize();
export default {
  components: {
    PrismEditor: DescMethod.PrismEditor,
  },
  data() {
    return {
      formData: { title: '' },
      DateCode1: Desc.DateCode1, //时间类配置片段
      DateCode2: Desc.DateCode2, //时间类配置片段
      DateCode3: Desc.DateCode3, //时间类配置片段
      DateCode4: Desc.DateCode4, //时间类配置片段
      activeNames: {}
    }
  },
  created() {

    // ------时间集默认值-----
    this.$set(this.formData, 'searchDateDay', getAllWeekBeforeNowFn('day').split(','))
    this.$set(this.formData, 'searchDateMonth', getAllWeekBeforeNowFn('month').split(','))
    // ----------- end ------

    // --- 时间组（默认值） ---
    this.$set(this.formData, 'searchDateStart2', getAllWeekBeforeNowFn().split(',')[0])
    this.$set(this.formData, 'searchDateEnd2', getAllWeekBeforeNowFn().split(',')[1])
    // ------------- end ---

    // 其他默认值
    this.$set(this.formData, 'searchDateToday', getAllWeekBeforeNowFn('today'))
    this.$set(this.formData, 'searchDate', getAllWeekBeforeNowFn().split(','))

    this.$set(this.formData, 'thirtyDaysStart', getAllWeekBeforeNowFn('monthRecent').split(',')[0])
    this.$set(this.formData, 'thirtyDaysEnd', getAllWeekBeforeNowFn('monthRecent').split(',')[1])


  },
  methods: {
    highlighter(code) {
      return DescMethod.highlight(code, DescMethod.languages.js);
    },
    htmlValue(val) {
      return DescMethod.htmlValue(val)
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep .gather {
  .el-form-item__label {
    color: #c58a8a !important;
  }
}
::v-deep .know-form {
  .el-form-item__label {
    color: #90d387 !important;
  }
}
::v-deep .el-collapse-item__header {
  padding-left: 10px;
  background-color: rgb(247, 247, 247) !important;
}
</style>